// Mock data for the application

// Patients database
export const patientsData = [
  {
    id: "1",
    name: "Giuseppe Verdi",
    fiscalCode: "VRDGPP80A01H501Z",
    dateOfBirth: "1980-01-01",
    age: 44,
    gender: "M",
    phone: "+39 333 1234567",
    email: "giuseppe.verdi@email.it",
    address: "Via Roma 10, Milano",
    bloodType: "A+",
    allergies: ["Penicillina"],
    chronicConditions: ["Diabete Tipo 2"],
    assignedDoctor: "doc1"
  },
  {
    id: "2",
    name: "Maria Bianchi",
    fiscalCode: "BNCMRA75B42F205X",
    dateOfBirth: "1975-02-02",
    age: 49,
    gender: "F",
    phone: "+39 334 7654321",
    email: "maria.bianchi@email.it",
    address: "Via Dante 25, Milano",
    bloodType: "O-",
    allergies: [],
    chronicConditions: ["Ipertensione"],
    assignedDoctor: "doc1"
  },
  {
    id: "3",
    name: "Antonio Russo",
    fiscalCode: "RSSANT65C15L219K",
    dateOfBirth: "1965-03-15",
    age: 59,
    gender: "M",
    phone: "+39 335 9876543",
    email: "antonio.russo@email.it",
    address: "Corso Magenta 8, Milano",
    bloodType: "B+",
    allergies: ["Aspirina"],
    chronicConditions: ["Ipercolesterolemia"],
    assignedDoctor: "doc2"
  },
  {
    id: "4",
    name: "Francesca Esposito",
    fiscalCode: "SPSFNC90D55H501W",
    dateOfBirth: "1990-04-15",
    age: 34,
    gender: "F",
    phone: "+39 336 1122334",
    email: "francesca.esposito@email.it",
    address: "Via Torino 42, Milano",
    bloodType: "AB+",
    allergies: [],
    chronicConditions: [],
    assignedDoctor: "doc1"
  },
  {
    id: "5",
    name: "Luca Romano",
    fiscalCode: "RMNLCU85E20F839P",
    dateOfBirth: "1985-05-20",
    age: 39,
    gender: "M",
    phone: "+39 337 4455667",
    email: "luca.romano@email.it",
    address: "Piazza Duomo 1, Milano",
    bloodType: "A-",
    allergies: ["Lattosio"],
    chronicConditions: ["Asma"],
    assignedDoctor: "doc2"
  },
  {
    id: "6",
    name: "Sofia Colombo",
    fiscalCode: "CLMSFO92H45F205Y",
    dateOfBirth: "1992-06-05",
    age: 32,
    gender: "F",
    phone: "+39 338 5566778",
    email: "sofia.colombo@email.it",
    address: "Via Montenapoleone 15, Milano",
    bloodType: "O+",
    allergies: [],
    chronicConditions: [],
    assignedDoctor: "doc1"
  },
  {
    id: "7",
    name: "Marco Ferrari",
    fiscalCode: "FRRMRC70L12H501T",
    dateOfBirth: "1970-07-12",
    age: 54,
    gender: "M",
    phone: "+39 339 6677889",
    email: "marco.ferrari@email.it",
    address: "Via Manzoni 22, Milano",
    bloodType: "B-",
    allergies: ["Sulfamidici"],
    chronicConditions: ["Diabete Tipo 2", "Ipertensione"],
    assignedDoctor: "doc2"
  },
  {
    id: "8",
    name: "Elena Ricci",
    fiscalCode: "RCCLNE88M55F205K",
    dateOfBirth: "1988-08-15",
    age: 36,
    gender: "F",
    phone: "+39 340 7788990",
    email: "elena.ricci@email.it",
    address: "Corso Buenos Aires 50, Milano",
    bloodType: "A+",
    allergies: [],
    chronicConditions: ["Ipotiroidismo"],
    assignedDoctor: "doc1"
  }
];

// Doctors database
export const doctorsData = [
  {
    id: "doc1",
    name: "Dr. Marco Bianchi",
    specialization: "Medicina Generale",
    email: "m.bianchi@medilab.it",
    phone: "+39 02 1234567",
    licenseNumber: "MI-12345",
    digitalSignatureId: "DS-MB-2024"
  },
  {
    id: "doc2",
    name: "Dr.ssa Laura Rossi",
    specialization: "Medicina Interna",
    email: "l.rossi@medilab.it",
    phone: "+39 02 7654321",
    licenseNumber: "MI-67890",
    digitalSignatureId: "DS-LR-2024"
  }
];

// Individual services with requiresReport flag
export const servicesData = [
  {
    id: "emocromo",
    name: "Emocromo",
    description: "Esame completo del sangue",
    category: "Analisi",
    duration: 5,
    requiresReport: true, // REQUIRES MEDICAL REPORT
    reportType: "Analisi Ematologica"
  },
  {
    id: "glicemia",
    name: "Glicemia",
    description: "Misurazione glucosio nel sangue",
    category: "Analisi",
    duration: 2,
    requiresReport: false
  },
  {
    id: "emoglobina_glicata",
    name: "Emoglobina Glicata",
    description: "HbA1c - controllo diabete",
    category: "Analisi",
    duration: 3,
    requiresReport: true, // REQUIRES MEDICAL REPORT
    reportType: "Analisi Metabolica"
  },
  {
    id: "colesterolo",
    name: "Colesterolo",
    description: "Profilo lipidico completo",
    category: "Analisi",
    duration: 3,
    requiresReport: true, // REQUIRES MEDICAL REPORT
    reportType: "Profilo Lipidico"
  },
  {
    id: "trigliceridi",
    name: "Trigliceridi",
    description: "Misurazione trigliceridi",
    category: "Analisi",
    duration: 2,
    requiresReport: false
  },
  {
    id: "pressione",
    name: "Pressione Arteriosa",
    description: "Misurazione PA sistolica/diastolica",
    category: "Parametri",
    duration: 2,
    requiresReport: false
  },
  {
    id: "ossimetria",
    name: "Ossimetria",
    description: "Saturazione ossigeno (SpO2)",
    category: "Parametri",
    duration: 1,
    requiresReport: false
  },
  {
    id: "ecg",
    name: "ECG",
    description: "Elettrocardiogramma",
    category: "Diagnostica",
    duration: 5,
    requiresReport: true, // REQUIRES MEDICAL REPORT
    reportType: "Referto Cardiologico"
  },
  {
    id: "spirometria",
    name: "Spirometria",
    description: "Test funzionalità polmonare",
    category: "Diagnostica",
    duration: 10,
    requiresReport: true, // REQUIRES MEDICAL REPORT
    reportType: "Referto Pneumologico"
  },
  {
    id: "temperatura",
    name: "Temperatura",
    description: "Temperatura corporea",
    category: "Parametri",
    duration: 1,
    requiresReport: false
  },
  {
    id: "peso",
    name: "Peso e BMI",
    description: "Peso, altezza e indice massa corporea",
    category: "Parametri",
    duration: 2,
    requiresReport: false
  },
  {
    id: "visus",
    name: "Test Visus",
    description: "Controllo acuità visiva",
    category: "Diagnostica",
    duration: 5,
    requiresReport: true, // REQUIRES MEDICAL REPORT
    reportType: "Referto Oculistico"
  }
];

// Service bundles with requiresReport indication
export const serviceBundlesData = [
  {
    id: "diabetes",
    name: "Controllo Diabete",
    description: "Monitoraggio completo per pazienti diabetici",
    services: ["glicemia", "emoglobina_glicata", "pressione", "peso"],
    requiresReport: true // Contains services that need reporting
  },
  {
    id: "cardiovascular",
    name: "Screening Cardiovascolare",
    description: "Valutazione rischio cardiovascolare",
    services: ["ecg", "pressione", "colesterolo", "trigliceridi"],
    requiresReport: true // Contains ECG and colesterolo
  },
  {
    id: "respiratory",
    name: "Controllo Respiratorio",
    description: "Monitoraggio funzionalità respiratoria",
    services: ["ossimetria", "spirometria", "temperatura"],
    requiresReport: true // Contains spirometria
  },
  {
    id: "complete",
    name: "Check-up Completo",
    description: "Valutazione completa dello stato di salute",
    services: ["emocromo", "glicemia", "pressione", "ecg", "ossimetria", "peso", "temperatura"],
    requiresReport: true // Contains emocromo and ECG
  },
  {
    id: "basic",
    name: "Controllo Base",
    description: "Parametri vitali di base",
    services: ["pressione", "ossimetria", "temperatura", "peso"],
    requiresReport: false // No services requiring report
  }
];

// Exam reports - pending and completed
export const examReportsData = [
  // Pending reports (waiting for doctor)
  {
    id: "rep1",
    examId: "exam1",
    patientId: "1",
    doctorId: "doc1",
    serviceId: "emocromo",
    serviceName: "Emocromo",
    examDate: "2026-01-27T09:30:00",
    status: "pending", // pending, in_review, signed, sent
    priority: "normal", // urgent, normal
    rawResults: {
      wbc: 7.2,
      rbc: 4.8,
      hgb: 14.5,
      hct: 42,
      plt: 250,
      mcv: 88,
      mch: 30,
      mchc: 34
    },
    report: null,
    signature: null
  },
  {
    id: "rep2",
    examId: "exam2",
    patientId: "2",
    doctorId: "doc1",
    serviceId: "ecg",
    serviceName: "ECG",
    examDate: "2026-01-27T10:15:00",
    status: "pending",
    priority: "urgent",
    rawResults: {
      heartRate: 72,
      rhythm: "Sinusale",
      prInterval: 160,
      qrsDuration: 90,
      qtInterval: 400
    },
    report: null,
    signature: null
  },
  {
    id: "rep3",
    examId: "exam3",
    patientId: "3",
    doctorId: "doc2",
    serviceId: "colesterolo",
    serviceName: "Colesterolo",
    examDate: "2026-01-27T11:00:00",
    status: "pending",
    priority: "normal",
    rawResults: {
      totalCholesterol: 220,
      hdl: 45,
      ldl: 150,
      triglycerides: 175
    },
    report: null,
    signature: null
  },
  {
    id: "rep4",
    examId: "exam4",
    patientId: "4",
    doctorId: "doc1",
    serviceId: "spirometria",
    serviceName: "Spirometria",
    examDate: "2026-01-26T14:30:00",
    status: "pending",
    priority: "normal",
    rawResults: {
      fev1: 3.2,
      fvc: 4.0,
      fev1Fvc: 80,
      pef: 8.5
    },
    report: null,
    signature: null
  },
  // In review
  {
    id: "rep5",
    examId: "exam5",
    patientId: "5",
    doctorId: "doc2",
    serviceId: "emocromo",
    serviceName: "Emocromo",
    examDate: "2026-01-26T09:00:00",
    status: "in_review",
    priority: "normal",
    rawResults: {
      wbc: 5.8,
      rbc: 4.5,
      hgb: 13.2,
      hct: 39,
      plt: 220,
      mcv: 86,
      mch: 29,
      mchc: 33
    },
    report: "Valori ematologici nella norma. Lieve riduzione dell'emoglobina rispetto al controllo precedente, da monitorare.",
    signature: null
  },
  // Signed - ready to send
  {
    id: "rep6",
    examId: "exam6",
    patientId: "6",
    doctorId: "doc1",
    serviceId: "ecg",
    serviceName: "ECG",
    examDate: "2026-01-25T10:00:00",
    status: "signed",
    priority: "normal",
    rawResults: {
      heartRate: 68,
      rhythm: "Sinusale",
      prInterval: 155,
      qrsDuration: 85,
      qtInterval: 390
    },
    report: "ECG nella norma. Ritmo sinusale regolare a 68 bpm. Nessuna alterazione del tratto ST. Intervalli nella norma.",
    signature: {
      doctorId: "doc1",
      signedAt: "2026-01-26T15:30:00",
      signatureId: "SIG-2026-0126-001",
      verified: true
    }
  },
  {
    id: "rep7",
    examId: "exam7",
    patientId: "7",
    doctorId: "doc2",
    serviceId: "emoglobina_glicata",
    serviceName: "Emoglobina Glicata",
    examDate: "2026-01-25T11:30:00",
    status: "signed",
    priority: "urgent",
    rawResults: {
      hba1c: 7.8,
      estimatedAvgGlucose: 177
    },
    report: "HbA1c al 7.8%, superiore al target terapeutico del 7%. Si consiglia rivalutazione della terapia antidiabetica in accordo con il medico curante. Programmato follow-up a 3 mesi.",
    signature: {
      doctorId: "doc2",
      signedAt: "2026-01-26T16:00:00",
      signatureId: "SIG-2026-0126-002",
      verified: true
    }
  },
  // Sent to patient
  {
    id: "rep8",
    examId: "exam8",
    patientId: "8",
    doctorId: "doc1",
    serviceId: "emocromo",
    serviceName: "Emocromo",
    examDate: "2026-01-24T09:00:00",
    status: "sent",
    priority: "normal",
    rawResults: {
      wbc: 6.5,
      rbc: 4.6,
      hgb: 13.8,
      hct: 41,
      plt: 235,
      mcv: 89,
      mch: 30,
      mchc: 34
    },
    report: "Esame emocromocitometrico nella norma. Tutti i parametri rientrano nei range di riferimento.",
    signature: {
      doctorId: "doc1",
      signedAt: "2026-01-24T14:00:00",
      signatureId: "SIG-2026-0124-001",
      verified: true
    },
    sentAt: "2026-01-24T15:00:00",
    sentTo: ["patient", "fascicolo"]
  }
];

// Appointments/Bookings
export const appointmentsData = [
  // Today
  { id: "a1", patientId: "1", date: "2026-01-27", time: "09:00", services: ["Controllo Diabete"], status: "completed", duration: 25 },
  { id: "a2", patientId: "2", date: "2026-01-27", time: "09:30", services: ["Emocromo", "Glicemia"], status: "completed", duration: 15 },
  { id: "a3", patientId: "3", date: "2026-01-27", time: "10:00", services: ["Pressione Arteriosa"], status: "in-progress", duration: 10 },
  { id: "a4", patientId: "4", date: "2026-01-27", time: "10:30", services: ["Ossimetria", "ECG"], status: "scheduled", duration: 20 },
  { id: "a5", patientId: "5", date: "2026-01-27", time: "11:00", services: ["Check-up Completo"], status: "scheduled", duration: 45 },
  { id: "a6", patientId: "6", date: "2026-01-27", time: "14:00", services: ["Glicemia"], status: "scheduled", duration: 10 },
  { id: "a7", patientId: "7", date: "2026-01-27", time: "15:00", services: ["Controllo Diabete"], status: "scheduled", duration: 25 },
  // Tomorrow
  { id: "a8", patientId: "8", date: "2026-01-28", time: "09:00", services: ["Screening Cardiovascolare"], status: "scheduled", duration: 30 },
  { id: "a9", patientId: "1", date: "2026-01-28", time: "10:00", services: ["Glicemia"], status: "scheduled", duration: 10 },
  { id: "a10", patientId: "3", date: "2026-01-28", time: "11:00", services: ["Colesterolo", "Trigliceridi"], status: "scheduled", duration: 15 },
  // Day after
  { id: "a11", patientId: "2", date: "2026-01-29", time: "09:30", services: ["Pressione Arteriosa"], status: "scheduled", duration: 10 },
  { id: "a12", patientId: "5", date: "2026-01-29", time: "14:00", services: ["Spirometria"], status: "scheduled", duration: 20 },
  // Next week
  { id: "a13", patientId: "4", date: "2026-02-02", time: "09:00", services: ["Check-up Completo"], status: "scheduled", duration: 45 },
  { id: "a14", patientId: "6", date: "2026-02-03", time: "10:00", services: ["Emocromo"], status: "scheduled", duration: 10 },
  { id: "a15", patientId: "7", date: "2026-02-04", time: "11:00", services: ["ECG"], status: "scheduled", duration: 15 },
];

// Clinical history / Past exam results
export const clinicalHistoryData = [
  // Giuseppe Verdi (Patient 1)
  {
    id: "h1",
    patientId: "1",
    date: "2026-01-27",
    services: ["Controllo Diabete"],
    results: [
      { name: "Glicemia", value: 98, unit: "mg/dL", status: "normal", range: "70-100" },
      { name: "Emoglobina Glicata", value: 6.2, unit: "%", status: "normal", range: "<7" },
      { name: "Pressione Sistolica", value: 125, unit: "mmHg", status: "normal", range: "90-120" },
      { name: "Pressione Diastolica", value: 82, unit: "mmHg", status: "normal", range: "60-80" },
      { name: "Peso", value: 78, unit: "kg", status: "normal", range: "-" },
      { name: "BMI", value: 25.1, unit: "", status: "high", range: "18.5-25" }
    ],
    notes: "Controllo di routine. Valori glicemici nella norma.",
    doctor: "Dr. Mario Rossi"
  },
  {
    id: "h2",
    patientId: "1",
    date: "2025-10-15",
    services: ["Controllo Diabete"],
    results: [
      { name: "Glicemia", value: 112, unit: "mg/dL", status: "high", range: "70-100" },
      { name: "Emoglobina Glicata", value: 6.8, unit: "%", status: "normal", range: "<7" },
      { name: "Pressione Sistolica", value: 130, unit: "mmHg", status: "high", range: "90-120" },
      { name: "Pressione Diastolica", value: 85, unit: "mmHg", status: "high", range: "60-80" }
    ],
    notes: "Glicemia leggermente elevata. Consigliata dieta.",
    doctor: "Dr. Mario Rossi"
  },
  {
    id: "h3",
    patientId: "1",
    date: "2025-07-20",
    services: ["Emocromo", "Glicemia"],
    results: [
      { name: "Glicemia", value: 105, unit: "mg/dL", status: "high", range: "70-100" },
      { name: "Globuli Bianchi", value: 7.2, unit: "K/µL", status: "normal", range: "4-11" },
      { name: "Globuli Rossi", value: 4.9, unit: "M/µL", status: "normal", range: "4.5-5.5" },
      { name: "Emoglobina", value: 14.8, unit: "g/dL", status: "normal", range: "13-17" }
    ],
    notes: "Emocromo nella norma.",
    doctor: "Dr. Mario Rossi"
  },
  // Maria Bianchi (Patient 2)
  {
    id: "h4",
    patientId: "2",
    date: "2026-01-27",
    services: ["Emocromo", "Glicemia"],
    results: [
      { name: "Glicemia", value: 92, unit: "mg/dL", status: "normal", range: "70-100" },
      { name: "Globuli Bianchi", value: 6.5, unit: "K/µL", status: "normal", range: "4-11" },
      { name: "Globuli Rossi", value: 4.3, unit: "M/µL", status: "normal", range: "4-5" },
      { name: "Emoglobina", value: 12.5, unit: "g/dL", status: "normal", range: "12-16" }
    ],
    notes: "Tutti i parametri nella norma.",
    doctor: "Dr. Mario Rossi"
  },
  {
    id: "h5",
    patientId: "2",
    date: "2025-11-10",
    services: ["Pressione Arteriosa"],
    results: [
      { name: "Pressione Sistolica", value: 145, unit: "mmHg", status: "high", range: "90-120" },
      { name: "Pressione Diastolica", value: 92, unit: "mmHg", status: "high", range: "60-80" },
      { name: "Frequenza Cardiaca", value: 78, unit: "bpm", status: "normal", range: "60-100" }
    ],
    notes: "Pressione elevata. Monitorare.",
    doctor: "Dr. Mario Rossi"
  },
  // Antonio Russo (Patient 3)
  {
    id: "h6",
    patientId: "3",
    date: "2026-01-20",
    services: ["Colesterolo", "Trigliceridi"],
    results: [
      { name: "Colesterolo Totale", value: 220, unit: "mg/dL", status: "high", range: "<200" },
      { name: "Colesterolo HDL", value: 45, unit: "mg/dL", status: "normal", range: ">40" },
      { name: "Colesterolo LDL", value: 150, unit: "mg/dL", status: "high", range: "<100" },
      { name: "Trigliceridi", value: 175, unit: "mg/dL", status: "high", range: "<150" }
    ],
    notes: "Profilo lipidico alterato. Consigliata terapia.",
    doctor: "Dr. Mario Rossi"
  },
  // Francesca Esposito (Patient 4)
  {
    id: "h7",
    patientId: "4",
    date: "2025-12-05",
    services: ["ECG", "Ossimetria"],
    results: [
      { name: "Frequenza Cardiaca", value: 72, unit: "bpm", status: "normal", range: "60-100" },
      { name: "Ritmo", value: "Sinusale", unit: "", status: "normal", range: "-" },
      { name: "SpO2", value: 99, unit: "%", status: "normal", range: "95-100" }
    ],
    notes: "ECG nella norma. Nessuna anomalia rilevata.",
    doctor: "Dr. Mario Rossi"
  },
  // Luca Romano (Patient 5)
  {
    id: "h8",
    patientId: "5",
    date: "2025-09-12",
    services: ["Spirometria"],
    results: [
      { name: "FEV1", value: 3.2, unit: "L", status: "normal", range: ">3" },
      { name: "FVC", value: 4.0, unit: "L", status: "normal", range: ">3.5" },
      { name: "FEV1/FVC", value: 80, unit: "%", status: "normal", range: ">70" }
    ],
    notes: "Funzionalità respiratoria nella norma.",
    doctor: "Dr. Mario Rossi"
  },
  // Marco Ferrari (Patient 7)
  {
    id: "h9",
    patientId: "7",
    date: "2025-12-20",
    services: ["Controllo Diabete"],
    results: [
      { name: "Glicemia", value: 135, unit: "mg/dL", status: "high", range: "70-100" },
      { name: "Emoglobina Glicata", value: 7.5, unit: "%", status: "high", range: "<7" },
      { name: "Pressione Sistolica", value: 148, unit: "mmHg", status: "high", range: "90-120" },
      { name: "Pressione Diastolica", value: 95, unit: "mmHg", status: "high", range: "60-80" }
    ],
    notes: "Valori non ottimali. Necessario adeguamento terapia.",
    doctor: "Dr. Mario Rossi"
  },
  {
    id: "h10",
    patientId: "7",
    date: "2025-09-15",
    services: ["Check-up Completo"],
    results: [
      { name: "Glicemia", value: 128, unit: "mg/dL", status: "high", range: "70-100" },
      { name: "Emoglobina Glicata", value: 7.2, unit: "%", status: "high", range: "<7" },
      { name: "Colesterolo Totale", value: 210, unit: "mg/dL", status: "high", range: "<200" },
      { name: "Pressione Sistolica", value: 142, unit: "mmHg", status: "high", range: "90-120" },
      { name: "ECG", value: "Normale", unit: "", status: "normal", range: "-" }
    ],
    notes: "Paziente a rischio cardiovascolare. Follow-up necessario.",
    doctor: "Dr. Mario Rossi"
  }
];

// Services statistics for BI
export const servicesStats = [
  { name: "Glicemia", count: 245, avgDuration: 8, category: "Analisi" },
  { name: "Pressione Arteriosa", count: 312, avgDuration: 5, category: "Parametri" },
  { name: "Emocromo", count: 156, avgDuration: 12, category: "Analisi" },
  { name: "Colesterolo", count: 134, avgDuration: 10, category: "Analisi" },
  { name: "ECG", count: 89, avgDuration: 15, category: "Diagnostica" },
  { name: "Ossimetria", count: 198, avgDuration: 3, category: "Parametri" },
  { name: "Controllo Diabete", count: 167, avgDuration: 25, category: "Bundle" },
  { name: "Spirometria", count: 45, avgDuration: 18, category: "Diagnostica" },
  { name: "Screening Cardiovascolare", count: 78, avgDuration: 30, category: "Bundle" },
  { name: "Check-up Completo", count: 56, avgDuration: 45, category: "Bundle" }
];

// Monthly performance data
export const monthlyPerformance = [
  { month: "Ago", prestazioni: 145, pazienti: 89 },
  { month: "Set", prestazioni: 178, pazienti: 102 },
  { month: "Ott", prestazioni: 203, pazienti: 115 },
  { month: "Nov", prestazioni: 189, pazienti: 108 },
  { month: "Dic", prestazioni: 156, pazienti: 94 },
  { month: "Gen", prestazioni: 167, pazienti: 98 }
];

// Age distribution
export const ageDistribution = [
  { range: "18-30", count: 45, percentage: 12 },
  { range: "31-45", count: 98, percentage: 26 },
  { range: "46-60", count: 134, percentage: 36 },
  { range: "61-75", count: 78, percentage: 21 },
  { range: "75+", count: 20, percentage: 5 }
];

// Gender distribution
export const genderDistribution = [
  { gender: "Maschi", count: 195, percentage: 52 },
  { gender: "Femmine", count: 180, percentage: 48 }
];

// Helper functions
export const getPatientById = (id) => patientsData.find(p => p.id === id);
export const getDoctorById = (id) => doctorsData.find(d => d.id === id);
export const getServiceById = (id) => servicesData.find(s => s.id === id);

export const getPatientHistory = (patientId) => 
  clinicalHistoryData.filter(h => h.patientId === patientId).sort((a, b) => new Date(b.date) - new Date(a.date));

export const getAppointmentsByDate = (date) => 
  appointmentsData.filter(a => a.date === date).sort((a, b) => a.time.localeCompare(b.time));

export const getPatientAppointments = (patientId) =>
  appointmentsData.filter(a => a.patientId === patientId).sort((a, b) => new Date(b.date) - new Date(a.date));

// Report helper functions
export const getPendingReportsByDoctor = (doctorId) =>
  examReportsData.filter(r => r.doctorId === doctorId && (r.status === 'pending' || r.status === 'in_review'))
    .sort((a, b) => {
      if (a.priority === 'urgent' && b.priority !== 'urgent') return -1;
      if (b.priority === 'urgent' && a.priority !== 'urgent') return 1;
      return new Date(a.examDate) - new Date(b.examDate);
    });

export const getSignedReportsReadyToSend = () =>
  examReportsData.filter(r => r.status === 'signed');

export const getAllPendingReports = () =>
  examReportsData.filter(r => r.status === 'pending' || r.status === 'in_review');

export const getReportsByStatus = (status) =>
  examReportsData.filter(r => r.status === status);

export const getServicesRequiringReport = () =>
  servicesData.filter(s => s.requiresReport);
